// extracted by mini-css-extract-plugin
module.exports = {"loadingIndicator":"LoadingIndicator_loadingIndicator__fWidd","spin":"LoadingIndicator_spin__UEaQu"};